import {
  ButtonV2,
  LabraToolTipV2,
  ModalConfirmV2,
  ModalSizeVariants,
  NoteColors,
  NoteV2,
} from '@labrav/react-components'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHashtag } from '@fortawesome/pro-regular-svg-icons'
import { buyerRegistrationModalMessage } from '../../utils/messagesConstants'
import { BuyerRegistrationPreviewModalHelpAndFaqs } from './BuyerRegistrationPreviewModalHelpAndFaqs'
import { CustomerCollectionForm } from '../CustomerCollectionForm/CustomerCollectionForm'

const noOps = () => void 0

export interface BuyerRegistrationPreviewButtonProps {
  isFormLocked?: boolean
  allValuesFilledForPreview: boolean
  buyerRegistrationPagePreviewMessage: string
  handlePreview: () => void
}

export interface BuyerRegistrationModalPreviewProps {
  open: boolean
  handleClose: () => void
}

export const BuyerRegistrationPreviewButton: React.FC<
  BuyerRegistrationPreviewButtonProps
> = ({
  isFormLocked,
  allValuesFilledForPreview,
  buyerRegistrationPagePreviewMessage,
  handlePreview,
}) => (
  <LabraToolTipV2
    followCursor={allValuesFilledForPreview}
    tooltipPlacement="top"
    description={
      allValuesFilledForPreview ? buyerRegistrationPagePreviewMessage : ''
    }
  >
    <ButtonV2
      data-testid="buyer-registration-page-preview-button"
      styleType="outlined"
      onClick={handlePreview}
      disabled={isFormLocked || allValuesFilledForPreview}
    >
      Preview buyer registration page
    </ButtonV2>
  </LabraToolTipV2>
)

export const BuyerRegistrationPreviewModal: React.FC<
  BuyerRegistrationModalPreviewProps
> = ({ open, handleClose }) => (
  <div data-testid="buyer-registration-preview-modal">
    <ModalConfirmV2
      title="Buyer registration page preview"
      description={
        <NoteV2
          backgroundColor={NoteColors.BLUE}
          description={buyerRegistrationModalMessage}
        />
      }
      content={open ? <CustomerCollectionForm /> : undefined}
      open={open}
      titleAcceptButton=""
      titleCancelButton=""
      onDecline={handleClose}
      variant={ModalSizeVariants.xLarge}
      hideAcceptButton={true}
      hideCancelButton={true}
      onAccept={noOps}
      secondaryActions={<BuyerRegistrationPreviewModalHelpAndFaqs />}
      icon={
        <FontAwesomeIcon
          icon={faHashtag}
          style={{ width: '20px', height: '16px' }}
        />
      }
    />
  </div>
)
